import React, {useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext, Controller } from 'react-hook-form';
import _ from 'lodash';
import { MenuItem, TextField } from '@mui/material';



export default function SelectInput(props) {
  const [t] = useTranslation();
  const { validate = [], industries, required = false } = props;
  const { register, errors, control } = useFormContext();
  const error = _.get(errors, name);
  const errorMessage = error?.message;


  // const validations = validate.reduce((acc, v) => Object.assign(acc, v), {});
  // const [currency, setCurrency] = React.useState('');
  // const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   // register(event.target.value);
  //   setCurrency(event.target.value);
  // };
  return (
    <Controller
      defaultValue=""
      name='industry'
      control={control}
      rules={{ required: required }}
      render={( 
        { onChange, onBlur, value, name, ref },
        { invalid, isTouched, isDirty } 
      ) => {
        // console.log('valuevaluevaluevalue', value);
        return (
          <TextField
            variant='standard'
            value={value}
            onChange={(e) => onChange(e.target.value)}
            // {...field}
            select
            fullWidth
            margin='dense'
            label="行业"
            placeholder={t('YBT-ADMIN.YBT-ADMIN-060101.YBT-ADMIN-06010106')}
            required={required}
            error={Boolean(error)}
            helperText={errorMessage}
          >
            {industries.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        );
      }}
    />
  );
}




